import _typeof from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.fixed.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { updateUser, uploadFile } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import { readCookie, dateFormatter } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.infoList = {}; // 价格列表
    _this.username = '';
    _this.nickname = '';
    _this.birthday = '';
    // 裁剪组件的基础配置option
    _this.option = {
      img: 'https://qn-qn-kibey-static-cdn.app-echo.com/goodboy-weixin.PNG',
      size: 1,
      full: false,
      outputType: 'png',
      canMove: true,
      fixedBox: false,
      original: false,
      canMoveBox: true,
      autoCrop: true,
      // 只有自动截图开启 宽度高度才生效
      autoCropWidth: 150,
      autoCropHeight: 150,
      centerBox: false,
      high: true
    };
    _this.show = true;
    _this.fixed = true;
    _this.fixedNumber = [1, 2];
    _this.showDialog = false;
    _this.isCropper = false;
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function () {
      var _created = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.setUserInfoList();
              this.nickname = this.userinfor.userinfolist.nickName;
              this.birthday = dateFormatter(this.userinfor.userinfolist.birthday);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function created() {
        return _created.apply(this, arguments);
      }
      return created;
    }() // 比较版本
  }, {
    key: "compareVersion",
    value: function compareVersion(v1, v2) {
      v1 = v1.split('.');
      v2 = v2.split('.');
      var len = Math.max(v1.length, v2.length);
      // 调整两个版本号位数相同
      while (v1.length < len) {
        v1.push('0');
      }
      while (v2.length < len) {
        v2.push('0');
      }
      // 循环判断每位数的大小
      for (var i = 0; i < len; i++) {
        var num1 = parseInt(v1[i]);
        var num2 = parseInt(v2[i]);
        if (num1 > num2) {
          return 1;
        } else if (num1 < num2) {
          return -1;
        }
      }
      return 0;
    }
    //  修改个人信息
  }, {
    key: "changeInfo",
    value: function () {
      var _changeInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this2 = this;
        var res, obj, anchor;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(dateFormatter(this.userinfor.userinfolist.birthday) === this.birthday)) {
                _context3.next = 13;
                break;
              }
              _context3.next = 3;
              return updateUser({
                nickName: this.nickname
              });
            case 3:
              res = _context3.sent;
              if (!(res.data.code === 100)) {
                _context3.next = 11;
                break;
              }
              _context3.next = 7;
              return this.setUserInfoList();
            case 7:
              this.$message.success('修改成功!');
              obj = {
                accessToken: readCookie('accessToken'),
                userName: this.userinfor.userinfolist.nickName,
                userId: this.userinfor.userinfolist.appUserExt.userId,
                userPhoto: this.userinfor.userinfolist.headImgUrl,
                macCode: '',
                phone: this.userinfor.userinfolist.phone,
                birthday: this.userinfor.userinfolist.birthday
              };
              anchor = readCookie('anchor');
              if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
                delete obj.accessToken;
                obj.token = res.data.data;
                this.webTransport.getUserLoginData(JSON.stringify(obj));
              } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
                delete obj.accessToken;
                obj.token = res.data.data;
                window.QCefClient.invokeMethod('getUserLoginData', JSON.stringify(obj));
              } else {
                window.JsIntrS.getUserLoginData(obj);
              }
            case 11:
              _context3.next = 14;
              break;
            case 13:
              this.$confirm('保存生效后，生日不能再次修改, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                var res, _obj, _anchor;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return updateUser({
                        nickName: _this2.nickname,
                        birthday: _this2.birthday
                      });
                    case 2:
                      res = _context2.sent;
                      if (!(res.data.code === 100)) {
                        _context2.next = 10;
                        break;
                      }
                      _context2.next = 6;
                      return _this2.setUserInfoList();
                    case 6:
                      _this2.$message.success('修改成功!');
                      _obj = {
                        accessToken: readCookie('accessToken'),
                        userName: _this2.userinfor.userinfolist.nickName,
                        userId: _this2.userinfor.userinfolist.appUserExt.userId,
                        userPhoto: _this2.userinfor.userinfolist.headImgUrl,
                        macCode: '',
                        phone: _this2.userinfor.userinfolist.phone,
                        birthday: _this2.userinfor.userinfolist.birthday
                      };
                      _anchor = readCookie('anchor');
                      if (_this2.compareVersion(_anchor.version, '3.10.600') >= 0) {
                        delete _obj.accessToken;
                        _obj.token = res.data.data;
                        _this2.webTransport.getUserLoginData(JSON.stringify(_obj));
                      } else if (_this2.compareVersion(_anchor.version, '3.6.5') >= 0) {
                        delete _obj.accessToken;
                        _obj.token = res.data.data;
                        window.QCefClient.invokeMethod('getUserLoginData', JSON.stringify(_obj));
                      } else {
                        window.JsIntrS.getUserLoginData(_obj);
                      }
                    case 10:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }))).catch(function () {});
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function changeInfo() {
        return _changeInfo.apply(this, arguments);
      }
      return changeInfo;
    }() // 上传头像
  }, {
    key: "getCropData",
    value: function () {
      var _getCropData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.showDialog = true;
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getCropData() {
        return _getCropData.apply(this, arguments);
      }
      return getCropData;
    }() // 图片裁剪
  }, {
    key: "uploadpic",
    value: function () {
      var _uploadpic = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(event) {
        var _this3 = this;
        var file, reader;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              file = event.target.files[0];
              reader = new FileReader();
              reader.onload = function (e) {
                var data;
                if (_typeof(e.target.result) === 'object') {
                  // 把Array Buffer转化为blob 如果是base64不需要
                  data = window.URL.createObjectURL(new Blob([e.target.result]));
                } else {
                  data = e.target.result;
                }
                _this3.option.img = data;
              };
              // 转化为base64
              // reader.readAsDataURL(file)
              // 转化为blob
              reader.readAsArrayBuffer(file);
              this.isCropper = true;
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function uploadpic(_x) {
        return _uploadpic.apply(this, arguments);
      }
      return uploadpic;
    }() // 取消上传
  }, {
    key: "cancelCropper",
    value: function cancelCropper() {
      this.$refs.clearFile.value = '';
      this.isCropper = false;
      this.showDialog = false;
    }
    // 上传图片
  }, {
    key: "confirmPic",
    value: function confirmPic() {
      var _this4 = this;
      this.$refs.cropper.getCropBlob(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(data) {
          var form, res, headImage, response, anchor, obj;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                form = new FormData();
                form.append('fileData', data);
                form.append('type', '11');
                _context6.next = 5;
                return uploadFile(form);
              case 5:
                res = _context6.sent;
                if (!(res.data.code === 100)) {
                  _context6.next = 24;
                  break;
                }
                headImage = res.data.data[0].sourceUrl;
                _context6.next = 10;
                return updateUser({
                  headImage: headImage
                });
              case 10:
                response = _context6.sent;
                if (!(response.data.code === 100)) {
                  _context6.next = 21;
                  break;
                }
                _this4.showDialog = false;
                _context6.next = 15;
                return _this4.setUserInfoList();
              case 15:
                anchor = readCookie('anchor');
                obj = {
                  accessToken: readCookie('accessToken'),
                  userName: _this4.userinfor.userinfolist.nickName,
                  userId: _this4.userinfor.userinfolist.appUserExt.userId,
                  userPhoto: _this4.userinfor.userinfolist.headImgUrl,
                  macCode: '',
                  phone: _this4.userinfor.userinfolist.phone,
                  birthday: _this4.userinfor.userinfolist.birthday
                };
                if (_this4.compareVersion(anchor.version, '3.10.600') >= 0) {
                  delete obj.accessToken;
                  obj.token = res.data.data;
                  _this4.webTransport.getUserLoginData(JSON.stringify(obj));
                } else if (_this4.compareVersion(anchor.version, '3.6.5') >= 0) {
                  delete obj.accessToken;
                  obj.token = res.data.data;
                  window.QCefClient.invokeMethod('getUserLoginData', JSON.stringify(obj));
                } else {
                  window.JsIntrS.getUserLoginData(obj);
                }
                _this4.$message.success('更改头像成功！');
                _context6.next = 22;
                break;
              case 21:
                _this4.$message.error(res.data.message);
              case 22:
                _context6.next = 25;
                break;
              case 24:
                _this4.$message.error(res.data.message);
              case 25:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "reupload",
    value: function reupload() {
      this.$refs.clearFile.value = '';
      this.isCropper = false;
    }
  }]);
}(Vue);
__decorate([Action('user/setUserInfoList')], default_1.prototype, "setUserInfoList", void 0);
__decorate([State('user')], default_1.prototype, "userinfor", void 0);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    NavMenu: NavMenu
  }
})], default_1);
export default default_1;